import * as app from 'CMS/core/application';
import * as $ from 'jquery';
import SearchResult from "AWFWSK/Data/DTOs/SearchResult/SearchResult";
import SuggestResult from 'AWFWSK/Data/DTOs/SearchResult/SuggestResult';

export default class SearchRepository {
    private url: string;
    private searchUrl: string;
    private suggestUrl: string;

    constructor(url?: string) {
        if (url == null || url === '') {
            url = app.formatLocationUrl('~/AWFWSK/api/Search'); // Default URL
        }
        this.url = url;
        this.searchUrl = url + '/Search';
        this.suggestUrl = url + '/Suggest';
    }

    public search(term: string): Promise<SearchResult[]> {
        return new Promise((resolve, reject) => {
            const $get = $.get(this.searchUrl + '?term=' + term);
            $get.then((data: any, textStatus: string, jqXHR: JQueryXHR) => {
                const results = data as any[];
                const searchResults = results.map((value, index, arr) => {
                    return this.toSearchResult(value);
                });
                resolve(searchResults);
            });
        });
    }

    public suggest(term: string): Promise<SuggestResult[]> {
        return new Promise((resolve, reject) => {
            const $get = $.get(this.suggestUrl + '?term=' + term);
            $get.then((data: any[], textStatus: string, jqXHR: JQueryXHR) => {
                const suggestResults = data.map((value, index, arr) => {
                    return this.toSuggestResult(value);
                });
                resolve(suggestResults);
            });

        });
    }

    private toSearchResult(dto: any): SearchResult {
        const searchResult = new SearchResult();
        searchResult.title = dto.title;
        searchResult.description = dto.description;
        searchResult.type = dto.type;
        searchResult.detailsPage = dto.detailsPage;
        return searchResult;
    }

    private toSuggestResult(dto: any): SuggestResult {
        const suggestResult = new SuggestResult();
        suggestResult.field = dto.field;
        suggestResult.suggestion = dto.suggestion;
        return suggestResult;
    }
}